import { gql } from 'graphql-request'
import { request } from 'graphql-request'
import {sitecoreApiKey, sitecoreApiHost, graphQLEndpointPath} from '../../../../temp/config'

export const SEARCH_QUERY = gql`
query Professions($brandcode: String!, $searchTerm: String!, $industry: String!) {
    professions(brandcode: $brandcode, searchTerm: $searchTerm, industry: $industry,) {
        results {
            businessClassId
            professionName
            brandCode
            businessUnitId
            forceRoute
        }
    }
}
`

export type SearchQueryResponse = {
    errors: {
      extensions: {
          code: string
      }
      message: string
    }
    professions: {
      results: ProfessionResult[] 
    }
}

export type ProfessionResult = {
    businessClassId: string
    professionName: string
    brandCode: string
    businessUnitId: string
    forceRoute: boolean
}


export async function fetchGraphQL(brandCode: string, searchTerm: string, industry: string): Promise<SearchQueryResponse | null> {
  try {
    const url = sitecoreApiHost + graphQLEndpointPath + "?sc_apiKey=" + sitecoreApiKey;
    const response: SearchQueryResponse = await request({
      url: url,
      document: SEARCH_QUERY,
      variables: {
        brandcode: brandCode,
        searchTerm: searchTerm,
        industry: industry,
      },
    });
    return response;
    
  } catch (error) {
    console.error('[TagResults] - GraphQL call failed:', error);
    return null;
  }
}
  
  